module.exports = __webpack_public_path__ + "img/online.460329eb.png";